import React, { forwardRef, useEffect, useState } from "react";
import { Col, Row, Grid, Modal } from "antd";
import { Link } from "react-router-dom";
import { SiNike } from "react-icons/si";
import { PiMoneyBold } from "react-icons/pi";
import { FaPeopleGroup } from "react-icons/fa6";
import moment from "moment";
import { EVENT_TYPES } from "../../../Config/helpers/constants";
import classes from "./index.module.css";

const { useBreakpoint } = Grid;

const EventCreateCard = forwardRef(({ data }, ref) => {
  const breakpoints = useBreakpoint();
  const [certificateCount, setcertificateCount] = useState(0);
  const [shieldCount, setshieldCount] = useState(0);
  const [totalCash, settotalCash] = useState(0);
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);

  useEffect(() => {
    const certificates = data?.event?.awards?.filter(
      (award) => award?.awardType === "certificate"
    )?.length;

    const shields = data?.event?.awards?.filter((award) => award?.awardType === "shield")?.length;

    const total = data?.event?.awards
      ?.filter((award) => award?.awardType === "cash")
      ?.reduce((sum, award) => sum + Number(award?.awardValue || 0), 0);

    setcertificateCount(certificates);
    setshieldCount(shields);
    settotalCash(total);
  }, [data]);

  const imageUrl = `${process.env.REACT_APP_API_URL}${data?.event?.file?.fileUrl}`;

  return (
    <>
      <div ref={ref}>
        <div
          className={`${classes.eventCard}`}
          style={{
            backgroundImage: `url("${imageUrl}")`,
            cursor: "pointer"
          }}
          onClick={() => setIsImagePreviewOpen(true)}>
          <Row
            justify="space-between"
            align="middle"
            style={{
              position: "absolute",
              zIndex: "10",
              top: 0,
              left: 0,
              background: "rgba(0,0,0,0.3)",
              color: "white",
              width: "100%",
              padding: "12px"
            }}>
            <Col className={classes.topleft}>
              <div className={classes.labelTag}>
                <strong>
                  {data?.type === EVENT_TYPES.SCRIM || data?.type === "event"
                    ? "Scrim"
                    : "Tournament"}
                </strong>
              </div>
              {data?.event?.typeofsports + ": " + data?.event?.nameofsports?.toUpperCase()}
            </Col>
            <Col className={classes.topright} style={{ color: "#fff", background: "#3de19c" }}>
              <Link to={`/view/event/${data.event._id}/timeline`} style={{ color: "#fff" }}>
                Registrations Open
              </Link>
            </Col>
          </Row>
        </div>

        <Row className={classes.eventbottom} align="middle">
          <Col className={classes.bottomright} order={`${breakpoints.md ? 1 : 2}`}>
            <div style={{ display: "flex", alignItems: "center", columnGap: "5px" }}>
              <FaPeopleGroup
                style={{
                  color: "purple",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"
                }}
              />
              <span style={{ fontWeight: 600 }}>
                Slots: {data?.event?.registerteams?.length || 0} /{" "}
                {data?.event?.maxParicipants || 0}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "5px",
                lineHeight: "2.5"
              }}>
              <PiMoneyBold style={{ color: "green" }} />
              <span style={{ fontWeight: 600 }}> Fee: {data?.event?.fee || 0} per team</span>
            </div>
            <div className={classes.sponsors}>
              <p>Sponsors:</p>
              <div>
                <SiNike style={{ fontSize: "0.5rem" }} />
              </div>
              <div style={{ borderLeft: "2px solid #e1e1e1", paddingLeft: "18px" }}>
                <SiNike style={{ fontSize: "0.5rem" }} />
              </div>
            </div>
          </Col>

          <Col className={classes.bottommiddle} xs={24} md={12} order={`${breakpoints.md ? 2 : 1}`}>
            <Link to={`/view/panel/${data?.panel?._id}/timeline/`}>
              <h2>By: {`${data?.panel?.name || "-"}`.toUpperCase()}</h2>
            </Link>
            <Link to={`/view/event/${data?.event?._id}/timeline`}>
              <h2>{`${data?.event?.name || "-"}`.toUpperCase()}</h2>
            </Link>
            <h2>
              Last date to Register:{" "}
              {moment.utc(data?.event?.deadline).format("D-MMM-YYYY, h:mm A")}
            </h2>
          </Col>

          <Col className={classes.bottomleft} order={3}>
            <div className={classes.moneyIcon}>
              <img alt="money" src="/images/icons/money-2.png" />
              <span>Rs {totalCash || 0}</span>
            </div>
            <div>
              <img alt="certificates" src="/images/icons/cert-2.png" />
              <span>{certificateCount || 0} certificates</span>
            </div>
            <div>
              <img alt="shield" src="/images/icons/shield-2.png" />
              <span>{shieldCount || 0} Shields</span>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        open={isImagePreviewOpen}
        footer={null}
        onCancel={() => setIsImagePreviewOpen(false)}
        centered
        width="90%"
        bodyStyle={{ padding: 0, textAlign: "center" }}>
        <img
          src={imageUrl}
          alt="Event Preview"
          style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
        />
      </Modal>
    </>
  );
});

export default EventCreateCard;
